export function formatCpf(cpf: string): string {
    if (!cpf) return "";
    // Remove any non-digit characters
    const digits = cpf.replace(/\D/g, "");
    // Format as 000.000.000-00
    if (digits.length !== 11) return cpf;
    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9, 11)}`;
}

export function validateCpf(cpf: string): boolean {
    if (!cpf) return false;
    // Remove any non-digit characters
    const digits = cpf.replace(/\D/g, "");
    if (digits.length !== 11 || /^(\d)\1{10}$/.test(digits)) return false;

    const calcCheckDigit = (base: string, factor: number): number => {
        let total = 0;
        for (let i = 0; i < base.length; i++) {
            total += parseInt(base.charAt(i)) * (factor - i);
        }
        const remainder = total % 11;
        return remainder < 2 ? 0 : 11 - remainder;
    };

    const firstCheckDigit = calcCheckDigit(digits.slice(0, 9), 10);
    const secondCheckDigit = calcCheckDigit(digits.slice(0, 10), 11);

    return firstCheckDigit === parseInt(digits.charAt(9)) && secondCheckDigit === parseInt(digits.charAt(10));
}

export function onlyDigits(cpf: string): string {
    if (!cpf) return "";
    return cpf.replace(/\D/g, "");
}